exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:992px){.mb-errors[data-v-14ccbed6]{margin-bottom:22px}}", ""]);

// exports
